export default __webpack_public_path__ + "static/media/upgrade-report10.a210cc45.png";